import { SwiperOptions } from 'swiper/types/swiper-options';

export const swiperDefaultConfig: SwiperOptions = {
  spaceBetween: 16,
  freeMode: true,
  grabCursor: true,
  breakpoints: {
    0: { slidesPerView: 3.6, slidesPerGroup: 3 },
    768: { slidesPerView: 4.35, slidesPerGroup: 4 },
    1024: { slidesPerView: 6.35, slidesPerGroup: 6 },
    1200: { slidesPerView: 6.35, slidesPerGroup: 6 },
    1440: { slidesPerView: 7.5, slidesPerGroup: 7 },
    1800: { slidesPerView: 9, slidesPerGroup: 8 },
  }
};
